// CitizenLayout.jsx (voorheen AppLayout)
import React, { useMemo, useState } from 'react';

export default function CitizenLayout({ sidebar, children, topOffsetPx = 64 }) {
  const [collapsed, setCollapsed] = useState(false);

  const sizes = useMemo(() => ({ expanded: 260, collapsed: 72 }), []);
  const railWidth = collapsed ? sizes.collapsed : sizes.expanded;

  return (
    <div>
      {/* VASTE LINKER RAIL (verbergt niets) */}
      <div
        style={{
          position: 'fixed',
          top: topOffsetPx,                   // uitlijnen met je topbar
          left: 0,
          width: railWidth,
          height: `calc(100vh - ${topOffsetPx}px)`,
          borderRight: '1px solid rgba(34,36,38,.1)',
          background: '#fff',
          overflowY: 'auto',
          zIndex: 10
        }}
      >
        {sidebar && sidebar({ collapsed, setCollapsed })}
      </div>

      {/* CONTENT – schuif op naast de rail en ook onder de topbar */}
      <div
        style={{
          marginLeft: railWidth,
          paddingTop: topOffsetPx,           // zelfde offset als rail
          minHeight: `calc(100vh - ${topOffsetPx}px)`
        }}
      >
        {children}
      </div>
    </div>
  );
}